import React, {ReactElement, HTMLAttributes, createContext} from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';

export const MobileContext = createContext<boolean | null>(null);

type Props = HTMLAttributes<HTMLDivElement>;

const MobileProvider: React.FC<Props> = ({children}: Props): ReactElement => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <MobileContext.Provider value={mobile}>{children}</MobileContext.Provider>
  );
};

export default MobileProvider;
